import { Badge } from "./ui/badge";

const LABELS = {
  NEW_REQUEST: { t: "Nouvelle demande", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  ASSIGNED_TO_CENTER: { t: "Assigné au centre", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  WAITING_CENTER_RESPONSE: { t: "En attente du centre", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  CENTER_AVAILABLE: { t: "Centre disponible", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  ALTERNATIVE_DATE_PROPOSED: { t: "Date alternative proposée", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  CENTER_UNAVAILABLE: { t: "Centre indisponible", cls: "bg-red-50 text-red-700 border-red-200" },
  PENDING_ADMIN_CONFIRMATION: { t: "À confirmer (admin)", cls: "bg-yellow-50 text-yellow-800 border-yellow-200" },
  CONFIRMED: { t: "Confirmé", cls: "bg-green-100 text-green-800 border-green-300" },
  CANCELLED: { t: "Annulé", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  COMPLETED: { t: "Réalisé", cls: "bg-primary-blue text-white border-primary-blue" },
  NO_SHOW: { t: "Absence", cls: "bg-red-100 text-red-700 border-red-200" },
  CLOSED: { t: "Clôturé", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export default function StatusBadge({ status }) {
  const info = LABELS[status] || { t: status, cls: "bg-slate-100 text-slate-700" };
  return <Badge variant="outline" className={`${info.cls} font-medium`}>{info.t}</Badge>;
}

export const STATUS_LABELS = LABELS;
